import { Fragment } from "react";
import styles from "./ComparisonTable.module.css";

import {
  COMPARISON_SECTIONS,
  getOtherBallrooms,
  getVenueSpaceList,
} from "./comparisonFields";

const hasValue = (value) => {
  if (
    value === null ||    value === undefined ||    value === "" ||    value === "—"  ) {
    return false;
  }

  if (Array.isArray(value)) {
    return value.length > 0;
  }
  return true;
};



function ComparisonTable({ hotels = [], onRemove }) {
  if (!hotels.length) return null;

  return (
    <div className={styles.tableWrapper}>
      <table className={styles.comparisonTable}>
        {/* =========================
            HOTEL HEADER
        ========================= */}

        <thead>
          <tr>
            <th className={styles.labelColumn}>
              Comparison
            </th>

            {hotels.map((hotel) => (
              <th
                key={hotel.id}
                className={styles.hotelColumn}
              >
                <div className={styles.hotelHeader}>
                  {hotel.featured_image && (
                    <img
                      src={hotel.featured_image}
                      alt={hotel.name || "Hotel"}
                      className={styles.hotelImage}
                    />
                  )}

                  <div className={styles.hotelName}>
                    {hotel.name || "Unnamed Hotel"}
                  </div>

                </div>
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {/* =========================
              DYNAMIC COMPARISON FIELDS
          ========================= */}

          {COMPARISON_SECTIONS.map((section) => (
            <Fragment key={section.title}>

              <tr>
                <th
                  colSpan={hotels.length + 1}
                  className={styles.sectionTitle}
                >
                  {section.title}
                </th>
              </tr>

              {section.fields.map((field) => {
  const values = hotels.map((hotel) =>
    field.getValue(hotel)
  );

  const hasAnyValue = values.some((value) =>
    hasValue(value)
  );

  if (!hasAnyValue) return null;

  return (
    <tr key={field.key}>
      <th className={styles.labelColumn}>
        {field.label}
      </th>

      {hotels.map((hotel) => (
        <td
          key={`${hotel.id}-${field.key}`}
          className={styles.valueColumn}
        >
          {field.getValue(hotel) ?? "—"}
        </td>
      ))}
    </tr>
  );
})}

            </Fragment>
          ))}

          {/* =========================
              BALLROOMS
          ========================= */}

          <tr>
            <th
              colSpan={hotels.length + 1}
              className={styles.sectionTitle}
            >
              Other Ballrooms
            </th>
          </tr>

<tr>
  <th className={styles.labelColumn}>
    Other Ballrooms
  </th>

  {hotels.map((hotel) => {
    const ballrooms = getOtherBallrooms(hotel);

    return (
      <td
        key={hotel.id}
        className={styles.valueColumn}
      >
        {ballrooms.length ? (
          <div className={styles.ballroomList}>
            {ballrooms.map((ballroom) => (
              <div
                key={ballroom.id}
                className={styles.ballroomItem}
              >
                <div className={styles.ballroomHeader}>
                  <strong className={styles.ballroomName}>
                    {ballroom.name}
                  </strong>

                  {ballroom.status && (
                    <span className={styles.ballroomStatus}>
                      {ballroom.status}
                    </span>
                  )}
                </div>

                {ballroom.carpet_area && (
                  <div className={styles.ballroomArea}>
                    {Number(
                      ballroom.carpet_area
                    ).toLocaleString("en-IN")}{" "}
                    sq.ft.
                  </div>
                )}

                {ballroom.capacities?.length > 0 && (
                  <div className={styles.capacityList}>
                    {ballroom.capacities.map(
                      (capacity) => (
                        <span
                          key={capacity.id}
                          className={styles.capacityItem}
                        >
                          <span
                            className={
                              styles.capacityLabel
                            }
                          >
                            {capacity.seating_type
                              .replaceAll("_", " ")
                              .replace(/\b\w/g, (c) =>
                                c.toUpperCase()
                              )}
                          </span>

                          <span
                            className={
                              styles.capacityValue
                            }
                          >
                            {Number(
                              capacity.capacity
                            ).toLocaleString("en-IN")}
                          </span>
                        </span>
                      )
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          "—"
        )}
      </td>
    );
  })}
</tr>
  

          <tr>
            <th
              colSpan={hotels.length + 1}
              className={styles.sectionTitle}
            >
              Other Venue Spaces
            </th>
          </tr>

          <tr>
            <th className={styles.labelColumn}>
              Available Spaces
            </th>

            {hotels.map((hotel) => {
              const spaces =
                getVenueSpaceList(hotel);

              return (
                <td
                  key={hotel.id}
                  className={styles.valueColumn}
                >
                  {spaces.length ? (
                    <div className={styles.listValue}>
                      {spaces.map((space) => (
                        <div key={space.id}>
                          <strong>
                            {space.name}
                          </strong>

                          {space.space_type && (
                            <span>
                              {space.space_type
                                .replaceAll(
                                  "_",
                                  " "
                                )
                                .replace(
                                  /\b\w/g,
                                  (c) =>
                                    c.toUpperCase()
                                )}
                            </span>
                          )}

                          {space.area && (
                            <span>
                              {Number(
                                space.area
                              ).toLocaleString(
                                "en-IN"
                              )}{" "}
                              sq.ft.
                            </span>
                          )}

                          {space.dimensions && (
                            <span>
                              {space.dimensions}
                            </span>
                          )}

                          {space.max_capacity && (
                            <span>
                              Capacity:{" "}
                              {Number(
                                space.max_capacity
                              ).toLocaleString(
                                "en-IN"
                              )}{" "}
                              guests
                            </span>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    "—"
                  )}
                </td>
              );
            })}
          </tr>

         
        </tbody>
      </table>
    </div>
  );
}

export default ComparisonTable;